import { useState } from "react";
import { toast } from "react-toastify";
import "../styles/RegisterAdmin.css";

export default function RegisterAdmin() {
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    isAdmin: false,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formData.password.length < 6) {
      toast.error("Password must be longer than 6 letters");
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/admin`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(formData),
        },
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to register admin");
      }

      toast.success("Admin registered successfully");
      setFormData({
        name: "",
        username: "",
        email: "",
        password: "",
        isAdmin: false,
      });
    } catch (err) {
      toast.error(err.message || "Failed to register admin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register__container">
      <h2>Register Admin</h2>
      <form onSubmit={handleSubmit} className="register__form">
        <div className="register__item">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            name="name"
            placeholder="Name"
            aria-label="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="register__item">
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            name="username"
            placeholder="Username"
            aria-label="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>
        <div className="register__item">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            name="email"
            placeholder="Email"
            aria-label="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="register__item">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            name="password"
            placeholder="Password"
            aria-label="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="register__item">
          <label htmlFor="isAdmin">isAdmin:</label>
          <input
            id="isAdmin"
            type="checkbox"
            name="isAdmin"
            aria-label="is administrator"
            checked={formData.isAdmin}
            onChange={handleChange}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="register__button my-btn"
        >
          {loading ? "Registering..." : "Register Admin"}
        </button>
      </form>
    </div>
  );
}
